<template>
<div class="header-container">
 <div class="top-menu">

  <div class="top-menu-icon-container">
   <div id="main-menu-icon" class="top-menu-icon-box">
    <svg id="i3" class="top-menu-icon" viewBox="0 0 100 100">
      <path id="top-line-3"     d="M30,37 L70,37 Z"></path>
      <path id="middle-line-3" 	d="M30,50 L70,50 Z"></path>
      <path id="bottom-line-3" 	d="M30,63 L70,63 Z"></path>
    </svg>  
   </div>
  </div>

  <div class="header-logo">
    ReviewStream
    <div class="header-moto">real consumers real experience</div>
  </div>
 </div>
 <div id="left-menu" class="header-left-menu">
    <div class="left-menu-container">

       <div class="left-menu-list" id="left-menu-list-2" @click="leftMenuClick('2')">
         <div class="left-menu-list-icon" id="left-menu-list-icon-home">
           <img src="./../assets/icons/left-menu/home.png" alt="Review Stream - real consumers, real experience" loading="lazy"/>
         </div>
         <div class="left-menu-list-link" id="left-menu-list-link-home">
           Home
         </div>
       </div> 

       <div class="left-menu-list" id="left-menu-list-1" @click="leftMenuClick('1')">
         <div class="left-menu-list-icon" id="left-menu-list-icon-sellreview">
           <img src="./../assets/icons/left-menu/sell-review.png" alt="Review Stream - monetize your experience" loading="lazy"/>
         </div>
         <div class="left-menu-list-link" id="left-menu-list-link-sellreview">
           Monetize your experience
         </div>
       </div>

       <div class="left-menu-list" id="left-menu-list-3" @click="leftMenuClick('3')">
         <div class="left-menu-list-icon" id="left-menu-list-icon-academy">
           <img src="./../assets/icons/left-menu/academy.png" alt="Review Stream - Content creation Academy" loading="lazy"/>
         </div>
         <div class="left-menu-list-link" id="left-menu-list-link-academy">
           Content creation Academy
         </div>
       </div> 
 
      <div class="left-menu-list" id="left-menu-list-4" @click="leftMenuClick('4')">
         <div class="left-menu-list-icon" id="left-menu-list-icon-faq">
           <img src="./../assets/icons/left-menu/faq.png" alt="Review Stream - Frequently asked questions" loading="lazy"/>
         </div>
         <div class="left-menu-list-link" id="left-menu-list-link-faq">
           Frequently asked questions
         </div>
       </div> 
 
    </div>
 </div>
</div> 
</template>


<script>
export default {
  name: "MainHeader",
  methods: {
    leftMenuClick: (link) => {
        if(link == 1){
          window.location.href = "/writereview.php";
        }
        if(link == 2){
          window.location.href = "/";
        }
        if(link == 3){
          window.location.href = "/academy/main.php";
        }
        if(link == 4){
          window.location.href = "/faq.php";
        }

      }
  }    


};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.header-container{
    width:100%;
    margin: 0;
    padding: 0;
    position: absolute;

}

.top-menu{
    width: 100%;
    height: calc(20px + 4vw + 4vh);
    position: fixed;
    z-index: 100;
    background-color: #FDF8F5;
    margin: 0;
    padding: 0;
    display:flex;
    transition: ease 0.4s;
}
.top-menu-scrolled{
  height:calc(20px + 2vw + 2vh);
}
.header-logo{
    text-align: center;
    position: relative;
    line-height: 60%;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 10px;
    font-family: 'Lobster';
    color: #E66D29;
    font-size: calc(12px + 3.2vw + 3.2vh);
    transition: ease 0.4s;
    letter-spacing: -2px;
}
.header-logo-scrolled{
    font-size:calc(12px + 1.6vw + 1.6vh);
}
.header-moto{
    width: 100%;
    line-height: 25px;
    color: #0A008F;
    font-size: calc(4px + 0.6vw + 0.6vh);
    font-family: 'Roboto';
    font-weight: 300;
    margin-left: 5px;
    text-align: left;
    transition: ease 0.4s;
    letter-spacing: 0;
}
.header-moto-scrolled{
    font-size:calc(4px + 0.3vw + 0.3vh);
    line-height:20px;
}
.top-menu-icon-container {
  width: calc(20px + 4vw + 4vh);
  height: calc(20px + 4vw + 4vh);
  transition: ease 0.4s;
}
.top-menu-icon-container-scrolled{
    width: calc(20px + 2vw + 2vh);
    height: calc(20px + 2vw + 2vh);
}
.top-menu-icon-box {
  width: 100%;
  height: 100%;
  background: #fed330;
}
.top-menu-icon {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
	width: 100%; 
  height: 100%;
	fill: none;
	stroke-width: 6;
	stroke-linecap: round;
	stroke-linejoin: round;
  cursor: pointer;
  stroke: #FFFFFF; 
  opacity: .95;
}
.header-left-menu{
  position:fixed;
  height:100vh;
  width:0;
  background: #fed330;
  left:0;
  top:calc(20px + 4vw + 4vh);
  z-index:100;
  transition: ease 0.4s;
}
.header-left-menu-scrolled{
  top:calc(20px + 2vw + 2vh);
}
.open-menu{
  width:80%;
}
.left-menu-container{
  width:95%;
  height:100%;
  margin-top:calc(10px + 2vw + 2vh);
  margin-left:10px;
  
}
.left-menu-list{
  width:100%;
  height:calc(10px + 3vw + 3vh);
  display:flex;
  margin-bottom: 30px;
}
.left-menu-list-icon{
  width:15%;
  height:100%;
}
.left-menu-list-icon img{
  width:100%;
  height:100%;
}
.left-menu-list-link{
    width: 75%;
    height: 100%;
    display: none;
    opacity:0;
    align-items: center;
    justify-content: left;
    padding-left: 10px;
    font-size: calc(6px + 1vw + 1vh);
    font-family: 'PT Serif';
    color: #0A008F;
    cursor:pointer;
    border-bottom: 1px solid #fdf8f5;
    transition: ease 0.1s;
}
.left-menu-list-link-close{
   transition: ease 0.8s;  
}
.left-menu-list-link:hover{
    border-bottom: 1px solid #0A008F;
}

@media (min-width: 768px) {
  .top-menu{
    height: calc(20px + 3vw + 3vh);
  }
  .top-menu-scrolled{
  height:calc(20px + 1.5vw + 1.5vh);
  }
  .top-menu-icon-container {
    width: calc(20px + 3vw + 3vh);
    height: calc(20px + 3vw + 3vh);
  }
  .top-menu-icon-container-scrolled{
    width: calc(20px + 1.5vw + 1.5vh);
    height: calc(20px + 1.5vw + 1.5vh);
  }
  .header-left-menu-scrolled{
    top: calc(20px + 1.5vw + 1.5vh) !important;
  }
  .header-moto{
    line-height: 40px;
    font-size: calc(4px + 0.5vw + 0.5vh);
  }
  .header-moto-scrolled{
    font-size:calc(4px + 0.25vw + 0.25vh);
    line-height:20px;
  }
  .header-left-menu{
    top:calc(20px + 3vw + 3vh);
  }
  .open-menu{
    width:25%;
  }
  .left-menu-list{
    height:calc(10px + 2vw + 2vh);
  }
  .left-menu-list-link{
    font-size:calc(6px + 0.7vw + 0.7vh);
  }
}

</style>
